import { Button, Grid, Group, Layout, Page } from "@/comn/components";
import { useFetch, useForm, useGrid, useResource, useStore, useToast, usePage } from "@/comn/hooks";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
    BASE,
    URLS,
    APIS,
    SF_EXRT_MGMT_SRCH,
    SG_EXRT_MGMT_LIST,
} from "@/tz/go/egaz/osci/ptl/info/exrt/services/OsciExrtMgmtService";

/*
 * Exchange Rate Management List
 * !== 환율 관리 목록 ==!
 */
export const OSCI0110003Q = (props: any) => {
    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0078" }],
    });

    const { pgeUid, menuId } = usePage();

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();

    const form = {
        exrtMgmtSrch: useForm({
            defaultSchema: SF_EXRT_MGMT_SRCH,
            defaultValues: {
                ...pgeStore?.form,
                ctraExrtMdfyDtStrt: comnUtils.getDate({ m: -1 }),
                ctraExrtMdfyDtEnd: comnUtils.getDate(),
            },
        }),
    };

    const grid = {
        exrtMgmtList: useGrid({
            defaultSchema: SG_EXRT_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        // Retrieve a list of Exchange Rate Managements. !== 환율관리 목록을 조회한다.==!
        getExrtMgmtList: useFetch({
            api: (page = grid.exrtMgmtList.page) =>
                APIS.getExrtMgmtList(form.exrtMgmtSrch.getValues(), page, grid.exrtMgmtList.size),
            enabled: comnUtils.isEmpty(form.exrtMgmtSrch.errors),
            key: [grid.exrtMgmtList.page, grid.exrtMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.exrtMgmtSrch.getValues(),
                    page: grid.exrtMgmtList.page,
                    size: grid.exrtMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
    };

    const render = {
        cell: {},
    };

    const handler = {
        getExrtMgmtList: () => {
            // Validate the search period before requesting exchange-rate data.
            form.exrtMgmtSrch.handleSubmit(
                () => {
                    grid.exrtMgmtList.setPage(0);
                    fetch.getExrtMgmtList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    useEffect(() => {
        handler.getExrtMgmtList();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.exrtMgmtSrch.schema.ctraExrtMdfyDt} controlSize={10} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.exrtMgmtSrch.schema.currCd} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.exrtMgmtSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button role={"search"} onClick={handler.getExrtMgmtList} />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.exrtMgmtList.grid}
                            data={fetch.getExrtMgmtList.data?.exrtMgmtList}
                            render={render}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
